const ROLE_CONFIG = {
  superadmin: { label: "SuperAdmin", border: "border-violet-200", text: "text-violet-600" },
  admin:      { label: "Admin",      border: "border-[#D5D5D5]", text: "text-[#666666]" },
  pro:        { label: "PRO",        border: "border-blue-200",   text: "text-blue-600" },
};

export function RoleBadge({ role }) {
  const config = ROLE_CONFIG[role];
  if (!config) return null;
  return (
    <span
      className={`inline-flex items-center rounded-full border ${config.border} px-2.5 py-0.5 text-[10px] font-medium tracking-wide ${config.text}`}
      data-testid="role-badge"
    >
      {config.label}
    </span>
  );
}
